import {

} from '@material-ui/core'
import React, { useState } from 'react'

import Calculator from './calculator'

function LandedCost(props) {

  const [pastCalcs, setPastCalcs] = useState([])
  const [savedCalcs, setSavedCalcs] = useState([])

  if (!savedCalcs.length && !pastCalcs.length)
    return <Calculator />

  return <>Not ready</>
}

export default LandedCost
export { default as Result } from './result'
